import { render, staticRenderFns } from "./ggDetail.vue?vue&type=template&id=39da6208&scoped=true&"
import script from "./ggDetail.vue?vue&type=script&lang=js&"
export * from "./ggDetail.vue?vue&type=script&lang=js&"
import style0 from "./ggDetail.vue?vue&type=style&index=0&id=39da6208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da6208",
  null
  
)

export default component.exports